<script>
// components
import vueCustomScrollbar from 'vue-custom-scrollbar'
import FileUploader from '@components/file-uploader/file-uploader.vue'
import MgbInput from '@components/inputs/_mgb-input.vue'
import MgbSelect from '@components/selects/_mgb-multiselect.vue'
import { ValidationObserver } from 'vee-validate'

// helpers
import { baseComputed, baseMethods } from '@state/helpers/base.js'
import {
    rightPanelMethods,
    rightPanelComputed,
} from '@state/helpers/right-panel.js'
import {
    fileManagerMethods,
    fileManagerComputed,
} from '@state/helpers/file-manager.js'
import { format, isBefore } from 'date-fns'
import { formatDate } from '@utils/date'
import axios from 'axios'
import teamProfiles from '@utils/team-profiles'
// Alerts
import { deleteAction, simpleSuccess, simpleWarning } from '@utils/alerts'

export default {
    components: {
        vueCustomScrollbar,
        FileUploader,
        ValidationObserver,
        'mgb-input': MgbInput,
        'mgb-select': MgbSelect,
    },
    data() {
        return {
            scrollSettings: {
                maxScrollbarLength: 60,
                swipeEasing: true,
                wheelSpeed: 0.3,
                wheelPropagation: false,
                fileRecords: [],
            },
            form: {
                currentFile: '',
                name: '',
                description: '',
                startDate: '',
                startTime: '',
                endDate: '',
                endTime: '',
                plans: [],
                profiles: [],
            },
        }
    },
    computed: {
        ...baseComputed,
        ...rightPanelComputed,
        ...fileManagerComputed,
        isStaffRoute() {
            return this.$route.path === '/file-manager'
        },
        panelHeader() {
            const panelText = {
                getFile: this.$t('Rightpanel.info'),
                newItem: this.$t('Rightpanel.addFile'),
                editFile: this.$t('Rightpanel.editFile'),
            }
            return panelText[this.panelContent.content]
        },
        profiles() {
            return teamProfiles()
        },
        fileProfiles() {
            return this.profiles.filter(({ value }) =>
                this.panelContent.file.item.roles.includes(parseInt(value))
            )
        },
        getIcon() {
            const fileType = this.panelContent.file.item.simpleType
            const icons = {
                excel: 'excel',
                powerPoint: 'powerPoint',
                pdf: 'pdf',
                image: 'image',
                text: 'text',
            }
            return `icn_${icons[fileType] || 'file'}`
        },
        getFilePlans() {
            const filePlansNames = this.planList
                .filter(({ publicId }) =>
                    this.panelContent.file.item.plans.some(
                        (plan) => plan === publicId
                    )
                )
                .map(({ name }) => name)
            return filePlansNames
        },
        optionPlans() {
            const options = [
                {
                    deselect: this.$t('Fields.select.selectAll'),
                    items: this.planList,
                },
            ]
            return options
        },
        optionProfiles() {
            const options = [
                {
                    deselect: this.$t('Fields.select.selectAll'),
                    items: this.profiles,
                },
            ]
            return options
        },
        isValidDateTimeValue() {
            if (this.form.endDate && this.form.endTime) {
                const initialDate = new Date(
                    `${formatDate(this.form.startDate)} ${this.form.startTime}`
                )
                const endDate = new Date(
                    `${formatDate(this.form.endDate)} ${this.form.endTime}`
                )
                return isBefore(initialDate, endDate)
            }
            return true
        },
        isFormPanel() {
            return (
                this.panelContent.content === 'editFile' ||
                this.panelContent.content === 'newItem'
            )
        },
    },
    watch: {
        'panelContent.content'(val) {
            if (this.isFormPanel) {
                if (val === 'newItem') this.resetForm()
                this.getPlanList({ GetAll: true })
                this.form.startDate = format(new Date(), 'dd/MM/yyyy')
            }
        },
        isRightPanelOpen(val) {
            if (this.panelContent && this.panelContent.content === 'newItem') {
                if (!val) this.resetForm()

                if (val) this.form.startDate = format(new Date(), 'dd/MM/yyyy')
            }
            if (val) {
                if (!this.planList) this.getPlanList({ GetAll: true })
            }
        },
    },
    async mounted() {
        // ao clicar em qualquer lugar fora do right panel, fechar
        // document.addEventListener('click', this.onBodyClick)
    },
    beforeDestroy() {
        // ao clicar em qualquer lugar fora do right panel, fechar
        // document.removeEventListener('click', this.onBodyClick)
    },
    methods: {
        ...baseMethods,
        ...rightPanelMethods,
        ...fileManagerMethods,
        shareFile() {
            const element = document.createElement('textarea')
            element.value = `${window.location.href}`
            document.body.appendChild(element)
            element.select()
            document.execCommand('copy')
            document.body.removeChild(element)
            this.$bvToast.toast(this.$t('Alerts.copyToClipboard'), {
                toastClass: 'mgb-toast',
                toaster: 'b-toaster-bottom-center',
                autoHideDelay: 3000,
                noCloseButton: true,
                solid: true,
            })
        },
        onBodyClick(e) {
            if (
                e.target.type === 'button' ||
                this.$refs.rightPanel.contains(e.target) ||
                e.target.tagName === 'TD' ||
                e.target.className === 'swal-overlay'
            )
                return
            this.closeRightPanel()
        },
        getFormatedDate(date) {
            return format(Date.parse(date), 'dd/MM/yyyy - HH:mm')
        },
        requestDelete() {
            deleteAction().then(async (value) => {
                if (!value) return
                const prefix = this.$route.query.prefix || ''
                const resp = await this.deleteFile({
                    fileName: `${this.panelContent.file.item.label}.${this.panelContent.file.item.extension}`,
                    prefix,
                })
                if (resp.status !== 200) return
                simpleSuccess('deletedSuccess')
                this.fetchFilesList()
            })
        },
        submitForm() {
            this.$refs.form.validate().then(async (success) => {
                if (!success) {
                    return
                }
                if (
                    this.panelContent.content === 'newItem' &&
                    !this.form.currentFile
                )
                    return simpleWarning('selectFile')
                if (!this.isValidDateTimeValue)
                    return simpleWarning('invalidDateValue')
                const { form } = this
                const formData = new FormData()
                // enviar prefix com as pastas da rota e do nome se houver / no nome
                if (this.$route.query.prefix || form.name.includes('/')) {
                    const routePrefix = this.$route.query.prefix || ''
                    const namePrefix = form.name.includes('/')
                        ? form.name.slice(0, form.name.lastIndexOf('/'))
                        : ''
                    formData.append('prefix', `${routePrefix}${namePrefix}`)
                } else {
                    formData.append('prefix', '')
                }
                if (this.panelContent.content === 'newItem') {
                    formData.append('file', form.currentFile)
                }
                if (this.panelContent.content === 'editFile') {
                    formData.append(
                        'extension',
                        this.panelContent.file.extension
                    )
                    formData.append(
                        'fileName',
                        form.name.substring(form.name.lastIndexOf('/') + 1)
                    )
                }
                formData.append(
                    'name',
                    form.name.substring(form.name.lastIndexOf('/') + 1)
                )
                form.plans.forEach(({ publicId }) => {
                    formData.append('plans', publicId)
                })
                form.profiles.forEach(({ value }) => {
                    formData.append('profiles', value)
                })
                formData.append('description', form.description)
                formData.append(
                    'StartDate',
                    format(
                        new Date(
                            `${formatDate(this.form.startDate)} ${
                                this.form.startTime
                            }`
                        ),
                        'dd/MM/yyyy HH:mm'
                    )
                )
                // se houver data final
                if (this.form.endDate) {
                    formData.append(
                        'EndDate',
                        format(
                            new Date(
                                `${formatDate(this.form.endDate)} ${
                                    this.form.endTime
                                }`
                            ),
                            'dd/MM/yyyy HH:mm'
                        )
                    )
                }
                const resp =
                    this.panelContent.content === 'newItem'
                        ? await this.createItem(formData)
                        : await this.putFile(formData)
                if (resp.status !== 200) return
                simpleSuccess('createdSuccess')
                this.toggleRightPanel()
                this.fetchFilesList()
                this.resetForm()
            })
        },
        onFileUpload(e) {
            this.form.currentFile = e
            this.form.name = e.name.replace(/\.[^/.]+$/, '')
        },
        fetchFilesList() {
            this.fetchList({
                prefix: this.$route.query.prefix || '',
                ipAddress: this.userIp,
                isUploadArea: this.isStaffRoute,
            })
        },
        resetForm() {
            Object.keys(this.form).map((prop) => {
                this.form[prop] = ''
            })
            if (this.$refs.form) this.$refs.form.reset()
            if (this.$refs.uploader) this.$refs.uploader.reset()
        },
        downloadFile() {
            const file = this.panelContent.file.item
            axios({
                url: file.id,
                method: 'GET',
                responseType: 'arraybuffer',
            }).then((resp) => {
                const url = window.URL.createObjectURL(new Blob([resp.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `${file.label}.${file.extension}`)
                document.body.appendChild(link)
                link.click()
                if (resp && resp.status === 200)
                    this.registerDownload(file.publicId)
            })
        },
        editFile() {
            const file = this.panelContent.file.item
            this.setPanelContent({
                content: 'editFile',
                file,
            })
            this.form.name = file.label
            this.form.description = file.description
            this.form.startTime = format(
                new Date(file.startAvailability),
                'HH:mm'
            )
            this.form.endDate = format(
                new Date(file.endAvalilability),
                'dd/MM/yyyy'
            )
            this.form.endTime = format(new Date(file.endAvalilability), 'HH:mm')
            this.form.plans = this.planList.filter(({ publicId }) =>
                file.plans.includes(publicId)
            )
            this.form.profiles = this.profiles.filter(({ value }) =>
                file.roles.includes(parseInt(value))
            )
        },
    },
}
</script>

<template>
    <div
        id="right-panel"
        ref="rightPanel"
        :class="{ 'full-sized': isRightPanelOpen }"
        class="right-panel rpanel"
    >
        <div class="right-panel__container pb-2">
            <vue-custom-scrollbar
                class="scroll-area"
                :settings="scrollSettings"
            >
                <b-container>
                    <b-row>
                        <b-col
                            class="right-panel__container-header d-flex justify-content-between align-items-center"
                        >
                            <svgicon
                                v-if="isFormPanel"
                                width="30"
                                height="30"
                                icon="icn_cloud"
                            />
                            <h4>{{ panelHeader }}</h4>
                            <svgicon
                                class="close-button"
                                width="18"
                                height="18"
                                icon="icn_error2"
                                color="#dc3545"
                                @click="toggleRightPanel"
                            />
                        </b-col>
                    </b-row>
                    <!-- Visualizar arquivo -->
                    <template v-if="panelContent.content === 'getFile'">
                        <b-row>
                            <b-col>
                                <div class="right-panel__file-type">
                                    <svgicon
                                        width="80px"
                                        height="80px"
                                        :icon="getIcon"
                                    />
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col
                                class="d-flex justify-content-between align-items-center"
                            >
                                <span
                                    class="right-panel__container-text mt-2"
                                    style="cursor: pointer"
                                    @click="shareFile"
                                >
                                    <svgicon
                                        width="16"
                                        height="16"
                                        icon="icn_share"
                                    />
                                    {{ $t('Rightpanel.share') }}
                                </span>
                                <span
                                    class="right-panel__container-text mt-2"
                                    style="cursor: pointer"
                                    @click.prevent="downloadFile"
                                >
                                    <svgicon
                                        width="16"
                                        height="16"
                                        icon="icn_download"
                                    />
                                    {{ $t('Rightpanel.download') }}
                                </span>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="text-center">
                                <p class="file-name">
                                    {{
                                        `${panelContent.file.item.label}.${panelContent.file.item.extension}`
                                    }}
                                </p>
                                <p class="mt-2">{{
                                    panelContent.file.item.description
                                }}</p>
                            </b-col>
                        </b-row>
                        <!-- extensão -->
                        <b-row class="mt-2">
                            <b-col>
                                <div class="right-panel__container-date">
                                    <span class="right-panel__container-text">
                                        {{ `${$t('Rightpanel.extension')}:` }}
                                    </span>
                                    <span>
                                        <strong>
                                            {{
                                                panelContent.file.item.extension
                                            }}
                                        </strong>
                                    </span>
                                </div>
                            </b-col>
                        </b-row>
                        <!-- downloads -->
                        <b-row>
                            <b-col>
                                <div class="right-panel__container-date">
                                    <span class="right-panel__container-text">
                                        {{ `Downloads:` }}
                                    </span>
                                    <span>
                                        <strong>
                                            {{
                                                panelContent.file.item
                                                    .downloadCount
                                            }}
                                        </strong>
                                    </span>
                                </div>
                            </b-col>
                        </b-row>
                        <!-- Datas do arquivo -->
                        <b-row>
                            <b-col class="d-flex flex-column">
                                <div class="right-panel__container-date">
                                    <span class="right-panel__container-text">
                                        {{ `${$t('Rightpanel.startDate')}:` }}
                                    </span>
                                    <span class="right-panel__container-text">
                                        <strong>
                                            {{
                                                ` ${getFormatedDate(
                                                    panelContent.file.item
                                                        .startAvailability
                                                )}`
                                            }}
                                        </strong>
                                    </span>
                                </div>
                                <div
                                    v-if="
                                        panelContent.file.item.endAvalilability
                                    "
                                    class="right-panel__container-date"
                                >
                                    <span class="right-panel__container-text">
                                        {{ `${$t('Rightpanel.endDate')}:` }}
                                    </span>
                                    <span class="right-panel__container-text">
                                        <strong>
                                            {{
                                                getFormatedDate(
                                                    panelContent.file.item
                                                        .endAvalilability
                                                )
                                            }}
                                        </strong>
                                    </span>
                                </div>
                            </b-col>
                        </b-row>
                        <!-- Tags -->
                        <!-- Planos aparecem apenas para staffs -->
                        <b-row v-if="isStaffRoute" class="mt-2">
                            <b-col>
                                <span style="font-size: 15px">
                                    {{ $t('Rightpanel.plans') }}:
                                </span>
                                <span
                                    v-for="(plan, index) in getFilePlans"
                                    :key="index"
                                    class="right-panel__container-tag blue-tag"
                                    >{{ plan }}
                                </span>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col>
                                <span style="font-size: 15px">
                                    {{ $t('Rightpanel.profiles') }}:
                                </span>
                                <span
                                    v-for="(role, index) in fileProfiles"
                                    :key="index"
                                    class="right-panel__container-tag"
                                    >{{ role.text }}
                                </span>
                            </b-col>
                        </b-row>
                        <!-- Botoes -->
                        <b-row v-if="isStaffRoute" class="mt-4">
                            <b-col class="d-flex justify-content-between">
                                <mgb-button
                                    variant="primary"
                                    @click.prevent="editFile"
                                    >{{ $t('Buttons.edit') }}</mgb-button
                                >
                                <mgb-button
                                    variant="danger"
                                    @click.prevent="requestDelete"
                                    >{{ $t('Buttons.delete') }}</mgb-button
                                >
                            </b-col>
                        </b-row>
                    </template>
                    <!-- Criar novo/Editar arquivo -->
                    <template v-if="isFormPanel">
                        <!-- upload do arquivo -->
                        <b-row v-if="panelContent.content === 'newItem'">
                            <b-col
                                ><FileUploader
                                    ref="uploader"
                                    @file-uploaded="onFileUpload"
                                />
                            </b-col>
                        </b-row>
                        <!-- Dados do arquivo -->
                        <b-row class="mt-3">
                            <b-col>
                                <ValidationObserver ref="form">
                                    <b-form
                                        class="right-panel__form"
                                        @submit.prevent="
                                            handleSubmit(submitForm)
                                        "
                                    >
                                        <b-row>
                                            <b-col>
                                                <mgb-input
                                                    id="file-name"
                                                    v-model="form.name"
                                                    :disabled="
                                                        panelContent.content !==
                                                            'newItem'
                                                    "
                                                    :name="
                                                        $t('Inputs.fileName')
                                                    "
                                                    :required="true"
                                                    rules="required|special-characters"
                                                />
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <mgb-input
                                                    id="file-description"
                                                    v-model="form.description"
                                                    :has-character-counter="
                                                        true
                                                    "
                                                    type="textarea"
                                                    :name="
                                                        $t('Inputs.description')
                                                    "
                                                    :character-limit="160"
                                                    :required="true"
                                                    rules="required"
                                                />
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <mgb-input
                                                    id="file-startDate"
                                                    v-model="form.startDate"
                                                    :mask="'##/##/####'"
                                                    :name="
                                                        $t('Inputs.initialDate')
                                                    "
                                                    :required="true"
                                                    rules="required|date-from-today"
                                                />
                                            </b-col>
                                            <b-col>
                                                <mgb-input
                                                    id="file-startTime"
                                                    v-model="form.startTime"
                                                    :mask="'##:##'"
                                                    :required="true"
                                                    :name="
                                                        $t(
                                                            'Inputs.classStartTime'
                                                        )
                                                    "
                                                    rules="required|valid-hour"
                                                />
                                            </b-col>
                                        </b-row>

                                        <b-row>
                                            <b-col>
                                                <mgb-input
                                                    id="file-endDate"
                                                    v-model="form.endDate"
                                                    :mask="'##/##/####'"
                                                    :name="$t('Inputs.endDate')"
                                                    rules="date-from-today"
                                                />
                                            </b-col>
                                            <b-col>
                                                <mgb-input
                                                    id="file-endTime"
                                                    v-model="form.endTime"
                                                    :mask="'##:##'"
                                                    :name="
                                                        $t(
                                                            'Inputs.classEndTime'
                                                        )
                                                    "
                                                    rules="valid-hour"
                                                />
                                            </b-col>
                                        </b-row>

                                        <b-row>
                                            <b-col>
                                                <mgb-select
                                                    id="select-plan"
                                                    v-model="form.plans"
                                                    :name="
                                                        $t('Inputs.plansSelect')
                                                    "
                                                    label="name"
                                                    track-by="name"
                                                    group-values="items"
                                                    group-label="deselect"
                                                    :group-select="true"
                                                    :rules="'required'"
                                                    :required="true"
                                                    :options="optionPlans"
                                                    :close-on-select="true"
                                                    :multiple="true"
                                                />
                                            </b-col>
                                        </b-row>

                                        <b-row>
                                            <b-col>
                                                <mgb-select
                                                    id="select-profile"
                                                    v-model="form.profiles"
                                                    :name="
                                                        $t(
                                                            'Inputs.profilesSelect'
                                                        )
                                                    "
                                                    label="text"
                                                    track-by="text"
                                                    group-values="items"
                                                    group-label="deselect"
                                                    :group-select="true"
                                                    :rules="'required'"
                                                    :required="true"
                                                    :options="optionProfiles"
                                                    :close-on-select="true"
                                                    :multiple="true"
                                                />
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col class="text-center">
                                                <mgb-button
                                                    type="submit"
                                                    variant="primary"
                                                    class="full-width"
                                                    @click.prevent="submitForm"
                                                    >{{
                                                        $t('Buttons.save')
                                                    }}</mgb-button
                                                >
                                            </b-col>
                                        </b-row>
                                    </b-form>
                                </ValidationObserver>
                            </b-col>
                        </b-row>
                    </template>
                </b-container>
            </vue-custom-scrollbar>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@src/design/components/right-panel';
</style>
